(function () {
  if (window.GibbonAboutUsInitialized) return;
  window.GibbonAboutUsInitialized = true;
  var initialized = new WeakSet();

  function initializeSlider(section) {
    if (!section || initialized.has(section)) return;

    var rail = section.querySelector('[data-about-slider-rail]');
    var previous = section.querySelector('[data-about-slider-previous]');
    var next = section.querySelector('[data-about-slider-next]');

    if (!rail || !previous || !next) return;
    initialized.add(section);

    function stepSize() {
      var card = rail.querySelector('.about-athletes__card');
      if (!card) return rail.clientWidth;
      var styles = window.getComputedStyle(rail);
      return card.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
    }

    function updateButtons() {
      var end = rail.scrollWidth - rail.clientWidth;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= end - 2;
    }

    previous.addEventListener('click', function () {
      rail.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      rail.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  }

  function initializeMedia(scope) {
    scope.querySelectorAll('[data-about-play]').forEach(function (button) {
      if (button.dataset.aboutInitialized === 'true') return;
      button.dataset.aboutInitialized = 'true';

      button.addEventListener('click', function () {
        var media = button.closest('.about-community__media, .about-athletes__media');
        if (!media || media.classList.contains('is-playing')) return;

        var video = media.querySelector('video');
        if (video) {
          video.controls = true;
          video.play();
          media.classList.add('is-playing');
          return;
        }

        var host = button.dataset.externalHost;
        var id = button.dataset.externalId;
        if (!host || !id) return;

        var iframe = document.createElement('iframe');
        iframe.className = 'about-external-video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = button.dataset.videoTitle || 'Video';
        iframe.src = host === 'vimeo'
          ? 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';

        media.querySelectorAll('img, video').forEach(function (element) {
          element.hidden = true;
        });
        media.prepend(iframe);
        media.classList.add('is-playing');
      });
    });
  }

  function initializeHeroMotion(scope) {
    var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    (scope || document).querySelectorAll('.about-founders').forEach(function (section) {
      if (section.dataset.aboutHeroMotionInitialized === 'true') return;
      section.dataset.aboutHeroMotionInitialized = 'true';

      var video = section.querySelector('.about-founders__hero-video');
      var iframe = section.querySelector('[data-about-hero-external]');

      function updateHeroMotion() {
        var reduceMotion = motionPreference.matches;

        if (video) {
          video.autoplay = !reduceMotion;
          video.controls = true;
          if (reduceMotion) {
            video.pause();
          } else {
            video.play().catch(function () {});
          }
        }

        if (iframe && iframe.dataset.src) {
          var source = iframe.dataset.src;
          if (reduceMotion) {
            source = source.replace(/([?&])autoplay=(1|true)/i, '$1autoplay=0');
          }
          if (iframe.src !== source) iframe.src = source;
        }
      }

      updateHeroMotion();
      if (motionPreference.addEventListener) {
        motionPreference.addEventListener('change', updateHeroMotion);
      } else if (motionPreference.addListener) {
        motionPreference.addListener(updateHeroMotion);
      }
    });
  }

  function initialize(scope) {
    (scope || document).querySelectorAll('[data-about-athletes]').forEach(initializeSlider);
    initializeMedia(scope || document);
    initializeHeroMotion(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
